<template>
  <div class="distributor-header" :class="bemFacets">
    <div class="distributor-header__item distributor-header__head">
      <h1 class="u-reset distributor-header__title">
        <slot name="title" />
      </h1>
    </div>
    <n-link :to="homeLink" class="u-reset distributor-header__item distributor-header__logo">
      <ui-icon class="distributor-header__icon" name="interaktionswerk-base" />
    </n-link>
  </div>
</template>

<script>
  import bemMixin from '@/assets/js/mixin/bem'
  import UiIcon from '@/components/ui-icon/ui-icon'
  import { ROUTE_IDS, ROUTE_LIST } from 'assets/js/util/nuxt/route'

  export default {
    components: { UiIcon },
    mixins: [bemMixin('distributor-header')],
    computed: {
      homeLink() {
        const { name } = ROUTE_LIST.find(({ id }) => id === ROUTE_IDS.HOME)
        return this.localePath({ name })
      },
    },
  }
</script>

<style lang="scss" src="./_distributor-header.scss" />
